<template>
  <sub-page title="企业服务">
    <div class="enterprise-page">
      <!-- 说明区域 -->
      <div class="info-card">
        <div class="info-title">企业服务</div>
        <div class="info-desc">
          本服务面向企业法人及经办人提供一站式人社服务。法人可对企业信息进行管理，经办人可代为办理相关业务。
        </div>
        <div class="info-item">
          <div class="info-label">
            <span class="label-dot dot-blue"></span>法人服务
          </div>
          <div class="info-text">企业信息管理、员工参保登记、缴费申报、待遇申领等</div>
        </div>
        <div class="info-item">
          <div class="info-label">
            <span class="label-dot dot-green"></span>经办人服务
          </div>
          <div class="info-text">代为办理员工参保、缴费查询、证明打印等业务</div>
        </div>
      </div>

      <!-- 底部按钮 -->
      <div class="btn-group">
        <button class="btn-primary" @click="handleLegal">我是法人</button>
        <button class="btn-secondary" @click="handleAgent">我是经办人</button>
      </div>
    </div>
  </sub-page>
</template>

<script>
import SubPage from './SubPage.vue'

export default {
  name: 'EnterpriseService',
  components: { SubPage },
  methods: {
    handleLegal() {
      this.$alert('法人登录')
    },
    handleAgent() {
      this.$alert('经办人登录')
    }
  }
}
</script>

<style scoped>
.enterprise-page {
  background: #F3F8FB;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  padding: calc(24 * var(--w));
}
.info-card {
  background: #fff;
  border-radius: calc(16 * var(--w));
  padding: calc(48 * var(--w)) calc(32 * var(--w));
  flex: 1;
  box-shadow: 0 calc(4 * var(--w)) calc(16 * var(--w)) rgba(0, 0, 0, 0.06);
}
.info-title {
  font-size: calc(40 * var(--w));
  font-weight: 600;
  color: #323233;
  margin-bottom: calc(20 * var(--w));
  display: flex;
  align-items: center;
  gap: calc(12 * var(--w));
}
.info-title::before {
  content: '';
  width: calc(8 * var(--w));
  height: calc(36 * var(--w));
  border-radius: calc(4 * var(--w));
  background: linear-gradient(180deg, #2E8CF6, #5EA9FA);
}
.info-desc {
  font-size: calc(28 * var(--w));
  color: #666;
  line-height: 1.7;
  margin-bottom: calc(48 * var(--w));
}
.info-item {
  background: #F3F8FB;
  border-radius: calc(12 * var(--w));
  padding: calc(28 * var(--w)) calc(24 * var(--w));
  margin-bottom: calc(24 * var(--w));
}
.info-item:last-child {
  margin-bottom: 0;
}
.info-label {
  font-size: calc(30 * var(--w));
  font-weight: 600;
  color: #323233;
  margin-bottom: calc(14 * var(--w));
  display: flex;
  align-items: center;
  gap: calc(12 * var(--w));
}
.label-dot {
  width: calc(16 * var(--w));
  height: calc(16 * var(--w));
  border-radius: 50%;
  flex-shrink: 0;
}
.dot-blue {
  background: linear-gradient(135deg, #2E8CF6, #5EA9FA);
  box-shadow: 0 0 0 calc(6 * var(--w)) rgba(46, 140, 246, 0.12);
}
.dot-green {
  background: linear-gradient(135deg, #07c160, #4ddb8f);
  box-shadow: 0 0 0 calc(6 * var(--w)) rgba(7, 193, 96, 0.12);
}
.info-text {
  font-size: calc(26 * var(--w));
  color: #969799;
  line-height: 1.6;
}
.btn-group {
  display: flex;
  gap: calc(24 * var(--w));
  padding: calc(40 * var(--w)) 0 calc(24 * var(--w));
}
.btn-primary,
.btn-secondary {
  flex: 1;
  height: calc(88 * var(--w));
  font-size: calc(32 * var(--w));
  font-weight: 500;
  border-radius: calc(44 * var(--w));
  cursor: pointer;
  border: none;
  transition: all 0.2s;
}
.btn-primary {
  background: linear-gradient(90deg, #2E8CF6, #5EA9FA);
  color: #fff;
  box-shadow: 0 calc(6 * var(--w)) calc(16 * var(--w)) rgba(46, 140, 246, 0.3);
}
.btn-primary:active {
  opacity: 0.9;
  transform: scale(0.98);
}
.btn-secondary {
  background: #fff;
  color: #2E8CF6;
  border: calc(2 * var(--w)) solid #2E8CF6;
}
.btn-secondary:active {
  background: rgba(46, 140, 246, 0.05);
}
</style>



// WEBPACK FOOTER //
// src/pages/EnterpriseService.vue